import React from "react";

export default function Roadmap() {
  return (
    <div className="roadmap">
      <div className="container">
        <div className="row">
          <div className="col-2"></div>
          <div className="col-12 col-lg-8">
            <h6>Phase 1</h6>
            <h5>Kancho Will Smith</h5>
            <img src="./Asserts/roadmap.png" className="img-fluid " alt="" />
            <h4>Kancho can hurt if not been done by a professional</h4>
          </div>
          <div className="col-2"></div>
        </div>
      </div>
    </div>
  );
}
